import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jira_ai_agent_avatar_calendar_view');
	},
};
